import { useCallback, useEffect, useRef, useState } from "react";
import { useApiCall } from "../apiHelpers";
import { DefaultTimeslots } from "../../../pages/Marketing/Timeslots/types";

const useGetDefaultTimeslots = () => {
    const { authFetch, isReady, run, isLoading, error } = useApiCall();
    const [data, setData] = useState<DefaultTimeslots | null>(null);

    const getDefaultTimeslots = useCallback(async (): Promise<DefaultTimeslots | null> => {
        const outcome = await run<DefaultTimeslots>(
            () => authFetch("/getDefaultTimeslots", { method: "GET" }),
            "An unknown error occurred",
        );
        if (!outcome.ok) return null;
        setData(outcome.data);
        return outcome.data;
    }, [authFetch, run]);

    const getDefaultTimeslotsRef = useRef(getDefaultTimeslots);
    getDefaultTimeslotsRef.current = getDefaultTimeslots;

    useEffect(() => {
        if (isReady) getDefaultTimeslotsRef.current();
    }, [isReady]);

    return { getDefaultTimeslots, loading: isLoading, error, data };
};

export default useGetDefaultTimeslots;
